exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resultados[data-v-087b1c74] {\n  margin-bottom: 15px;\n}\n.resultados .no-more[data-v-087b1c74] {\n  color: #b0b0b0;\n  font-size: 18px;\n  font-weight: 100;\n  border-top: 1px dashed #ddd;\n  padding-top: 15px;\n  margin-bottom: 15px;\n}\n@media (min-width: 992px) {\n.resultados[data-v-087b1c74] {\n    min-height: 100vh;\n}\n}", ""]);

// exports
